module.exports = __webpack_public_path__ + "img/hr-tree-06-e-leaves.520fa7c4.png";